import FavoriteDataPresenter from "../components/favorite/favorite-data/presenter/favorite-data.js";

const favoriteDataComponent = new FavoriteDataPresenter();
favoriteDataComponent.init();
